export default __webpack_public_path__ + "static/media/web_devices.77401a63.svg";